import { IChase } from "../../types/IChase";
import { endpoint } from "../../utils/endpoint";
import { axiosGet, axiosPost } from "../axiosRequests";

const getLeadChaseEndpoint = (leadId: string) => endpoint(`app/v1.0/leads/${leadId}/chases`);

export const getChases = async (leadId: string): Promise<IChase[]> => {
  const response = await axiosGet(getLeadChaseEndpoint(leadId));

  return response.data.data;
};

export const postChase = async (leadId: string, userId: string): Promise<IChase> => {
  const response = await axiosPost(getLeadChaseEndpoint(leadId), {
    userId,
  });

  return response.data;
};
